import type { FaireProductEntity } from "../../entity_types/product";

export const p_2ss973wkpa: FaireProductEntity = {
  token: "p_2ss973wkpa",
  type: "product",
  name: "66Leopard Print Color Block Trim Sweater Cardigan (S-XL)",
  brandToken: "b_fpqcwkn7v8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e1bbd87a256bfbbaf7e4a812e7fc49a01e789fe4526066cebdd2e00ab84bb9be.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b96d5a7a61a2c731413676e5a2fb8b732f5bbc9e2a193c46895c3ce1947ca12e.png",
    "https://cdn.faire.com/fastly/3a80d5fe83c5567dd05655ce8becc703caca81feeb32a962526f80b0ca379b8f.jpeg",
    "https://cdn.faire.com/fastly/0363967b19f9bacf9b7920bf6178d1ca798e884ce8d49a2dfe256c09f266cfd7.jpeg",
    "https://cdn.faire.com/fastly/329402325a63be8e2526e1559d7bae049acadfd99c16ec910189ceb775c16daa.jpeg",
    "https://cdn.faire.com/fastly/9f348d927584ab88ae7725cd77487e2271aecab876449c459c49e681366b734c.jpeg",
    "https://cdn.faire.com/fastly/fc3426962cd1f8ac35ec730c9231583001636f3faa39fedf371a27c860b85a34.jpeg",
    "https://cdn.faire.com/fastly/6d76cccccbb03f4bc18359a20fb90525fbd077a71ae4daf4dfbb9e42dd43b4ea.jpeg",
    "https://cdn.faire.com/fastly/94a958d8f2cb137ebe9864e5a835b92f8bfee6c32cb8ee84f634077c61a0b130.jpeg",
    "https://cdn.faire.com/fastly/9f94866afe4928215bd9b7009750220ce6b622dd5754cfea17a15b1b740aacff.jpeg",
    "https://cdn.faire.com/fastly/1916b6738f57c1aabd64425bd2a5525f2569beecbba34697adaa34ab4a89838b.jpeg",
    "https://cdn.faire.com/fastly/acf1408670d10fb471095bc325de7dbae0cbd0010b02d158e9674c47be40af76.jpeg",
  ],
  priceDollars: 33.88,
  description:
    "🎀Material: 70%Polyester+20%Acrylic+10%Polyamide\n😍Why You’ll Love It?\n\nBold leopard print is elegantly contained by sharp color-block trimming, offering a sophisticated visual contrast.\nCozy oversize fit creates a comfortable, trendy, and effortlessly slouchy silhouette perfect for layering.\nFunctional button-down front allows for versatile styling—wear it open as a layer or closed as a sweater.\nSoft, chunky knit fabric provides essential warmth and a comfortable drape for cold-weather chic.\n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!\nWestern apparel",
  tags: [],
  msrpDollars: 67.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:15.339Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
